import { emailTemplateService } from '../services'

const state = {
    all: {
        loading: false,
        total: 0,
        rows: []
    },
    loading: false,
    emailVariables: {
        loading: false,
        basic: [],
        advanced: []
    }
}

const actions = {

    getAll ({ dispatch, commit }, params) {
        commit('getAllRequest')
        emailTemplateService.getAll(params).then(
            response => {
                commit('getAllSuccess', response)
            }
        )
    },

    get ({ dispatch, commit }, { id, offerId }) {
        commit('startRequest')
        return emailTemplateService.get({ id, offerId }).then(
            response => {
                commit('endRequest', response)
                return response;
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable load email template, template not exists', { root: true })
            }
        )
    },

    add({ dispatch, commit }, params) {
        commit('startRequest')
        return emailTemplateService.add(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Email Template created successfully', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to create email template: ' + error, { root: true })
            }
        )
    },

    update({ dispatch, commit }, params) {
        commit('startRequest')
        return emailTemplateService.update(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Email Template updated successfully', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to update email template: ' + error, { root: true })
            }
        )
    },

    remove({ dispatch, commit }, id) {
        commit('startRequest')
        return emailTemplateService.delete(id).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Email Template deleted successfully', { root: true })
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to delete email template: ' + error, { root: true })
            }
        )
    },

    reload({ dispatch, commit }) {
        emailTemplateService.getAll({}).then(
            response => {
                commit('getAllSuccess', response)
            }
        )
    },

    getEmailVariables ({ dispatch, commit }) {
        commit('getEmailVariablesRequest')
        emailTemplateService.getEmailVariables().then(
            response => {
                commit('getEmailVariablesSuccess', response)
            },
            error => {
                commit('getEmailVariablesError')
                dispatch('alert/error', 'Unable to load email template variables: ' + error, { root: true })
            }
        )
    }

}

const mutations = {
    getAllRequest (state, params) {
        state.all = { loading: true, total: 0, rows: [] }
    },
    getAllSuccess (state, data) {
        state.all = { loading: false, total: data.total, rows: data.rows }
    },
    startRequest (state) {
        state.loading = true
    },
    endRequest (state) {
        state.loading = false
    },
    getEmailVariablesRequest (state) {
        state.emailVariables.loading = true
    },
    getEmailVariablesSuccess (state, data) {
        state.emailVariables = { loading: false, basic: data.basic, advanced: data.advanced }
    },
    getEmailVariablesError (state) {
        state.emailVariables.loading = false
    }
}

const getters = {
    isLoadingEmailTemplates (state) {
        return state.all.loading === true
    },
    getEmailTemplatesLength (state) {
        return state.all.total
    },
    getEmailTemplates (state) {
        return state.all.rows
    },
    isBusy (state) {
        return state.loading === true
    },
    getTemplatesForSelect (state) {
        let options = [];
        state.all.rows.map(row => {
            options.push({
                'value': row.id,
                'text': row.name,
                'action_name': row.action_name
            })
        })

        return options
    },
    getEmailTemplateBasicVariables (state) {
        return state.emailVariables.basic
    },
    getEmailTemplateAdvancedVariables (state) {
        return state.emailVariables.advanced
    }
}

export const emailTemplateModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
